import { Component, OnInit } from '@angular/core';
import { FleetService } from '../../fleet-service/fleet.service';

@Component({
  selector: 'app-late-onscene-reason',
  templateUrl: './late-onscene-reason.component.html',
  styleUrls: ['./late-onscene-reason.component.css']
})
export class LateOnsceneReasonComponent implements OnInit {
  lateReasons: any = [];
  constructor(private fleetService: FleetService) { }

  ngOnInit() {
    this.getLateReason();
  }

  getLateReason(){
  this.fleetService.getLateReasons().subscribe(data=>{
    if(data){
    this.lateReasons = data;
    }
  })
  }

}
